/**
 * This is a placeholder. Please import from one of the sub-packages, e.g `@ishop/admin-ui/core`
 */
export const placeholder = 'Vendure Admin UI';
